import { render, staticRenderFns } from "./RemolcadorEstado.vue?vue&type=template&id=af4dc334"
import script from "./RemolcadorEstado.vue?vue&type=script&lang=js"
export * from "./RemolcadorEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports